if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
      
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
      
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      
        this.hideErrors = this.dataset.hideErrors === 'true';

        var upgradePopupWrap = document.querySelector('.womens-popup');
        var upgradePopupOverlay = document.querySelector('.popup-overlay');
        var upgradeClose = document.querySelector('.close');
        var upgradeCloseDeclines = document.querySelectorAll('.btn-decline');
        var upgradeBtns = document.querySelectorAll('.btn-upgrade');

        this.submitButton.addEventListener('click', function (e) {
            e.preventDefault();
            var subsIdToAdd = e.currentTarget.getAttribute('data-subs-id');
            var memrbershipOption = document.querySelector('.loop-widget-container div[data-loop-widget-selling-plan-group]');

            if (memrbershipOption?.classList.contains('loop-widget-purchase-option-selected')) {
                // var frequencyInterval = this.frequencyInterval;
                // var unitType = 'Months';
                // this.addItemToCart(subsIdToAdd, '1', frequencyInterval, unitType);
                this.onSubmitHandler();
            } else {
                e.preventDefault();
                upgradePopupWrap.style.display = 'block';
                upgradePopupOverlay.style.display = 'block';
                document.querySelector('body').style.overflow = 'hidden';
            }
        }.bind(this)); // Bind the outer 'this' context to the inner function

        upgradeBtns.forEach((btn) => {
            btn.addEventListener('click', (e) => {
                var upgradeId = e.currentTarget.getAttribute('data-upgrade-id');
                document.querySelector('body').style.overflow = '';
                upgradePopupWrap.style.display = 'none';
                upgradePopupOverlay.style.display = 'none';

                console.log(upgradeId);

                this.onSubmitHandlerSubsctiption(upgradeId);
            });
        });

        upgradeClose.addEventListener('click', () => {
            document.querySelector('body').style.overflow = '';
            upgradePopupWrap.style.display = 'none';
            upgradePopupOverlay.style.display = 'none';
            this.onSubmitHandler();
        });

        upgradeCloseDeclines.forEach((btn) => {
            btn.addEventListener('click', () => {
                document.querySelector('body').style.overflow = '';
                upgradePopupWrap.style.display = 'none';
                upgradePopupOverlay.style.display = 'none';
                this.onSubmitHandler();
            });
        });
        
      }

      addItemToCart(subsIdToAdd, qty, frequencyInterval, unit_type) {
        this.onSubmitHandlerSubsctiption(subsIdToAdd);
      }

      onSubmitHandler(evt) {
        // evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
              if (typeof fbq === 'function') {
                fbq('track', 'AddToCart', {
                  content_ids: [response.id],
                  content_name: response.title,
                  content_type: 'product',
                  value: (response.price / 100).toFixed(2),
                  currency: response.currency || window.ShopifyAnalytics.meta.currency
                });
              }
            }
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');

            var priceValueOneTime = document.querySelector('.product-form__submit .price.regular').textContent;

            // Twitter conversion tracking event code
            if (typeof twq === 'function') {
                twq('event', 'tw-oe79k-oe7bb', {
                    value: priceValueOneTime,
                    currency: window.ShopifyAnalytics.meta.currency
                });
            }
            
          });
      }

      onSubmitHandlerSubsctiption(evt) {
        // evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        formData.set("id", evt);
        
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {              
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
              if (typeof fbq === 'function') {
                fbq('track', 'AddToCart', {
                  content_ids: [response.id],
                  content_name: response.title,
                  content_type: 'product',
                  value: (response.price / 100).toFixed(2),
                  currency: response.currency || window.ShopifyAnalytics.meta.currency
                });
              }
            }
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');

            var priceValueMembership = document.querySelector('div[data-loop-widget-selling-plan-group] .loop-widget-purchase-option-price').textContent;

            // Twitter conversion tracking event code
            if (typeof twq === 'function') {
                twq('event', 'tw-oe79k-oe7bb', {
                    value: priceValueMembership,
                    currency: window.ShopifyAnalytics.meta.currency
                });
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
